<template>
  <div class="Rectangle">
    <div class="reaction-icon-container">
      <img src="../../assets/share/like.svg" />
      <p>{{ likesCountInKilo }}</p>
      <!-- #TODO When numbers exceed one thousad use Kilo represenation 1.4K likes  -->
    </div>
    <div class="reaction-icon-container">
      <img src="../../assets/share/dislike.svg" />
    </div>
    <div class="reaction-icon-container">
      <img src="../../assets/share/share.svg" />
      <p v-if="sharesCount > 0">{{ sharesCountInKilo }}</p>
    </div>
    <div class="reaction-icon-container">
      <img src="../../assets/share/Favorite.svg" />
    </div>
    <div class="award-icon-container">
      <img src="../../assets/share/award.svg" />
    </div>
  </div>
</template>


<script>
import { convertNumberToKiloNotation } from "../../../../helpers/formatters";

export default {
  name: "ReactionsBar",

  props: {
    likesCount: {
      type: Number,
    },
    dislikesCount: {
      type: Number,
    },
    sharesCount: {
      type: Number,
    },
  },
  computed: {
    likesCountInKilo() {
      return convertNumberToKiloNotation(this.likesCount);
    },
    sharesCountInKilo() {
      return convertNumberToKiloNotation(this.sharesCount);
    },
  },
};
</script>


<style scoped>
.Rectangle {
  padding: 1rem 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  right: 0.5rem;
  row-gap: 1rem;
  /* width: 67px; */
  /* height: 437.1px; */
  /* margin: 206.1px 24px 306.7px 280px; */
  /* right: 15.9px; */
  /* top: 25%; */
  /* padding: 34.7px 15.2px 23.6px 11.5px; */
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  /* display: flex; */
  z-index: 100;
  border-radius: 40px;
  text-align: center;
}

/* Media queries for "---HEIGHT---"  */
@media only screen and (max-height: 400px) {
  .Rectangle {
    top: 15% !important;
    height: 71vh !important;
    row-gap: 0.8rem;
  }
  img {
    width: 1.4rem !important;
  }
}

@media only screen and (min-height: 401px) and (max-height: 500px) {
  .Rectangle {
    top: 15% !important;
    height: 60vh !important;
  }
  img {
    width: 1.4rem !important;
  }
}

@media only screen and (min-height: 1024px) {
  .Rectangle {
    right: 1rem;
    top: 25%;
    height: 27rem;
  }
  img {
    width: 3rem;
  }
  p {
    color: white;
    line-height: 0rem;
    margin: 0.5rem 0 0 0;
    padding: 0;
  }
}
/* Other Media queries   */

@media only screen and (min-width: 50px) {
  .Rectangle {
    right: 1rem;
    top: 25%;
    height: 17rem;
  }
  img {
    width: 1.75rem;
  }
  p {
    color: white;
    line-height: 0rem;
    margin: 0.5rem 0 0 0;
    padding: 0;
  }
}

@media only screen and (min-width: 300px) {
  .Rectangle {
    right: 1rem;
    top: 25%;
    height: 20rem;
  }
  img {
    width: 2rem;
  }
  p {
    color: white;
    line-height: 0rem;
    margin: 0.5rem 0 0 0;
    padding: 0;
  }
}

@media only screen and (min-width: 650px) {
  .Rectangle {
    right: 1rem;
    top: 25%;
    height: 20rem;
  }
  img {
    width: 2.5rem;
  }
  p {
    color: white;
    line-height: 0rem;
    margin: 0.2rem 0 0 0;
    padding: 0;
  }
}

@media only screen and (min-width: 650px) {
  /* Size for samsung fold- dual screen mode */
  .Rectangle {
    right: 1rem;
    top: 25%;
    height: 20rem;
  }
  img {
    width: 2.5rem;
  }
  p {
    color: white;
    line-height: 0rem;
    margin: 0.2rem 0 0 0;
    padding: 0;
  }
}

@media only screen and (min-width: 800px) {
  .Rectangle {
    right: 1rem;
    top: 25%;
    height: 27rem;
  }
  img {
    width: 3rem;
  }
  p {
    color: white;
    line-height: 0rem;
    margin: 0.5rem 0 0 0;
    padding: 0;
  }
}

@media only screen and (min-width: 800px) {
  .Rectangle {
    right: 1rem;
    top: 25%;
    height: 24rem;
  }
  img {
    width: 2.5rem;
  }
  p {
    color: white;
    line-height: 0rem;
    margin: 0.5rem 0 0 0;
    padding: 0;
  }
}

@media only screen and (min-height: 1024px) {
  .Rectangle {
    right: 1rem;
    top: 25%;
    height: 27rem;
  }
  img {
    width: 3rem;
  }
  p {
    color: white;
    line-height: 0rem;
    margin: 0.5rem 0 0 0;
    padding: 0;
  }
}
.reaction-icon-container p {
  font-size: 16px;
}
/* .reaction-icon-container {
  position: relative;
  margin: auto;
  padding-bottom: 2%;
}

.award-icon-container {
  margin-top: 10%;
}
.imgreaction {
  position: relative;
  margin: auto;
} */
</style>